// extracted by mini-css-extract-plugin
export var contentBody = "_a7-9";
export var headerImage = "_a7-2";
export var imageButton = "_a7-7";
export var imageButtonIcon = "_a7-8";
export var imageHeader = "_a7-4";
export var imageHeaderText = "_a7-5";
export var imageOverlay = "_a7-3";
export var imageTitle = "_a7-6";
export var imageWrapper = "_a7-1";
export var taskList = "_a7-a";
export var widget = "_a7-0";